import script from "./OfferList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferList.vue?vue&type=script&setup=true&lang=ts"

import "./OfferList.vue?vue&type=style&index=0&id=5c3236be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3236be"]])

export default __exports__